import axios from 'axios'
import {Notification, Message} from 'element-ui'
import {getToken} from '@/utils/auth'
import {tansParams} from "@/utils/ruoyi";
import store from '@/store'
import errorCode from '@/utils/errorCode'
import {BASE_URL} from '@/conifg'
import router from '../router'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分
    baseURL: BASE_URL,
    // 超时
    timeout: 100000
})

// request拦截器
service.interceptors.request.use(config => {
    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false
    if (getToken() && !isToken) {
        config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    // get请求映射params参数
    if (config.method === 'get' && config.params) {
        let url = config.url + '?' + tansParams(config.params);
        url = url.slice(0, -1);
        config.params = {};
        config.url = url;
    }
    return config
}, error => {
    console.log(error)
    Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
        // 未设置状态码则默认成功状态
        const code = res.data.code || 200;
        // 获取错误信息
        const msg = errorCode[code] || res.data.msg || errorCode['default']
        if (code === 401) {
            Message({
                message: '未登录或登录状态已过期，请重新登录',
                type: 'error',
                onClose: function () {
                    store.dispatch('LogOut').then(() => {
                        location.href = `/login?redirect=${store.getters.urlName}`;
                    })
                }
            })
            return Promise.reject('令牌验证失败')
        } else if (code === 500) {
            Message({
                message: msg,
                type: 'error'
            })
            return Promise.reject(new Error(msg))
        } else if (code === 200401) {
            Message({
                message: msg,
                type: 'error',
                onClose: function () {
                    const pathname = window.location.pathname;
                    // 不是数据中心返回上一级页面
                    if (pathname.indexOf("dataCenter") === -1) {
                        location.href = `/${store.getters.urlName}`;
                    } else {
                        if (document.referrer.indexOf("login") === -1) {
                            // 如果是登录页面就返回首页
                            location.href = '/';
                        } else {
                            // 否则返回上一个页面
                            window.history.back();
                        }
                    }
                }
            })
            return Promise.reject(new Error(msg))
        } else if (code !== 200) {
            Notification.error({
                title: msg
            })
            return Promise.reject('error')
        } else {
            return res.data
        }
    },
    error => {
        console.log('err' + error)
        let {message} = error;
        if (message === "Network Error") {
            message = "后端接口连接异常";
        } else if (message.includes("timeout")) {
            message = "系统接口请求超时";
        } else if (message.includes("Request failed with status code")) {
            message = "系统接口" + message.substr(message.length - 3) + "异常";
        }
        Message({
            message: message,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    }
)

export default service
